import { useSelector } from 'react-redux';
import { getSettings } from './index';

export const usePlayerSettings = () => useSelector(getSettings);
